module.exports = __webpack_public_path__ + "static/media/metalizado-transferivel-350x210.05e63641.png";